import React, { useRef, Suspense } from "react";
import {
  Canvas,
  useFrame,
  useThree,
  useLoader,
  extend,
  ReactThreeFiber
} from "@react-three/fiber";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
extend({ OrbitControls });

import "./ThreeSixtyViewer.scss";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      orbitControls: any;
    }
  }
}

interface Props {
  src: string;
}

const Sphere = ({ src }: Props) => {
  const mesh = useRef<THREE.Mesh>(null);
  const texture = useLoader(THREE.TextureLoader, src);
  return (
    <mesh ref={mesh} scale={[-1, 1, 1]}>
      <sphereGeometry args={[500, 60, 40]} attach="geometry" />
      <meshBasicMaterial
        map={texture}
        attach="material"
        side={THREE.BackSide}
      />
    </mesh>
  );
};

const Controls = () => {
  const { camera, gl } = useThree();
  const controls = useRef<OrbitControls>();
  useFrame(() => controls.current?.update());
  return (
    <orbitControls
      ref={controls}
      target={new THREE.Vector3(0, 0, 0)}
      args={[camera, gl.domElement]}
      enableDamping={true}
      dampingFactor={0.2}
      autoRotate={true}
      autoRotateSpeed={-1}
      rotateSpeed={-0.4}
    />
  );
};

const ThreeSixtyViewer = ({ src }: Props) => {
  return (
    <Canvas camera={{ position: [0, 0, 0.001] }}>
      <Controls />
      <Suspense fallback={null}>
        <Sphere src={src} />
      </Suspense>
    </Canvas>
  );
};

export default React.memo(ThreeSixtyViewer, (prevProps, nextProps) => {
  return prevProps.src == nextProps.src;
});
